import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../config/Api";

export const uploadImageToCloudinary = createAsyncThunk<string, File>(
    "/sellerUploadToCloudinary/uploadImage",
    async (file, { rejectWithValue }) => {
      try {
        const formData = new FormData();
        formData.append("file", file);
  
        const response = await api.post("/api/cloudinary/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
           meta: { skipLoader: true, silent: true }
        });
  
        return response.data.url ;
      } catch (error: any) {
        console.log("error: ",error);
        return rejectWithValue(error.response?.data || "Upload failed");
      }
    }
  );
  

interface SellerUploadToCloudinary{
    url:string|null,
    loading:boolean,
    error:string|null
}

const initialState:SellerUploadToCloudinary={
    url:null,
    loading:false,
    error:null
}

const sellerUploadToCloudinarySlice = createSlice({
    name:"sellerCloudinary",
    initialState,
    reducers:{},
    extraReducers:(builder)=>{
        builder.addCase(uploadImageToCloudinary.pending,(state)=>{
            state.loading=true
        })
        .addCase(uploadImageToCloudinary.fulfilled,(state,action:PayloadAction<string>)=>{
            state.loading=false,
            state.url=action.payload
        })
        .addCase(uploadImageToCloudinary.rejected,(state)=>{
          state.loading=false
          state.error="Fail to upload image"
        })
    }

})

export const sellerUploadToCloudinaryReducer = sellerUploadToCloudinarySlice.reducer